module.exports = __webpack_public_path__ + "img/quests.84bb7502.png";